import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { Timestampable } from "./concerns/timestampable"

// Timestamps para vimeo_player y youtube_player
// Ejemplo:
//     <a data-controller="video-timestamp"
//        data-video-timestamp-timestamp-value="00:20:03"
//        data-video-timestamp-vimeo-player-outlet="div[data-controller=vimeo-player]"
//        data-video-timestamp-youtube-player-outlet="div[data-controller=youtube-player]"
//        data-action="click->video-timestamp#setPlayerToTimestamp"
//        href="#"
//     >Yôganidrá</a>
export default class extends Controller {

  static values = {
    timestamp: String
  }
  static outlets = [ "vimeo-player", "youtube-player" ]

  initialize() {
    Loggable(this, {debug: false})
    Timestampable(this)
    this.hasTimestampClass = this.element.classList.contains("video-timestamp")
    this.initiallyHidden = this.element.classList.contains("d-none")
  }

  connect() {
    this.scopePublicationOutlets()
    this.refreshAvailability()
  }

  scopePublicationOutlets() {
    const scope = this.element.closest("[data-video-timestamp-player-id]")
    const publication = this.element.closest(".community-publication[id]")
    const playerId = scope?.dataset.videoTimestampPlayerId || (publication && `video_player_${publication.id}`)
    if (!playerId) return

    for (const provider of ["vimeo", "youtube"]) {
      const key = `${provider}-player-outlet`
      const selector = `[data-controller=${provider}-player]`
      if (this.data.get(key) === selector) {
        this.data.set(key, `#${playerId}${selector}`)
      }
    }
  }

  vimeoPlayerOutletConnected() { this.refreshAvailability() }
  vimeoPlayerOutletDisconnected() { this.refreshAvailability() }
  youtubePlayerOutletConnected() { this.refreshAvailability() }
  youtubePlayerOutletDisconnected() { this.refreshAvailability() }

  refreshAvailability() {
    if (this.hasTimestampClass) {
      this.element.classList.toggle("video-timestamp", this.hasLinkedPlayer())
    } else {
      this.element.classList.toggle("d-none", this.initiallyHidden || !this.hasLinkedPlayer())
    }
  }

  hasLinkedPlayer() {
    return this.hasVimeoPlayerOutlet || this.hasYoutubePlayerOutlet
  }

  setPlayerToTimestamp(event) {
    event.preventDefault()
    this.log("setPlayerToTimestamp", this.timestampValue)
    if (this.hasVimeoPlayerOutlet) {
      this.vimeoPlayerOutlet.setPosition(this.timestampToSeconds(this.timestampValue))
    }
    if (this.hasYoutubePlayerOutlet) {
      this.youtubePlayerOutlet.setPosition(this.timestampToSeconds(this.timestampValue))
    }
  }
}
